import { render, staticRenderFns } from "./bank-slip.vue?vue&type=template&id=4929e2e6&scoped=true"
var script = {}
import style0 from "./bank-slip.vue?vue&type=style&index=0&id=4929e2e6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4929e2e6",
  null
  
)

export default component.exports